<template>
  <!--活跃用户统计图-->
  <div class="CampusRank">
    <div class="titlegaga">月活统计(万)</div>
    <div id="MonthActive"></div>
  </div>
</template>
  
  <script>
import G2 from '@antv/g2';

export default {
  name: 'MonthActiveMember',
  props: ['data'],
  data() {
    return {
      chart: null,
      max: 0,
      min: 0,
    };
  },
  methods: {
    handleData() {
      let data = this.data;
      let returnValue = [];
      for (let i = 0; i < data.length; i++) {
        let currentValue = data[i];
        for (const key in currentValue) {
          if (key == 'allActive') {
            let va = {
              company: '总活跃人数(单位:万)',
              type: currentValue.name,
              value: parseInt(currentValue[key] / 10000),
            };
            returnValue.push(va);
          }
          if (key == 'appActive') {
            // let va = {
            //   company: 'App活跃数(单位:万)',
            //   type: currentValue.name,
            //   value: parseInt(currentValue[key]/10000)
            // };
            // returnValue.push(va);
          }
          if (key == 'hardwareActive') {
            // let va = {
            //   company: '硬件活跃数(单位:万)',
            //   type: currentValue.name,
            //   value: parseInt(currentValue[key]/10000)
            // };
            // returnValue.push(va);
          }
        }
      }
      return returnValue;
    },
    initChart() {
      let data = this.handleData();
      this.max = -1;
      this.min = -1;

      data.forEach(item => {
        if (this.max == -1) {
          this.max = item.value;
        } else {
          if (item.value > this.max) {
            this.max = item.value;
          }
        }
        if (this.min == -1) {
          this.min = item.value;
        } else {
          if (item.value < this.min) {
            this.min = item.value;
          }
        }
      });
      console.error(this.max, this.min);
      if (!this.chart) {
        this.chart = new G2.Chart({
          container: 'MonthActive',
          forceFit: true,
          height: window.innerHeight / 4 + 20,
          // width:window.outerWidth/3,
          padding: [20, '2%', 50, '2%'],
        });
        this.chart.source(data);
        // this.chart.scale('value', {
        //   alias: '活跃数量',
        //   max: 75,
        //   min: 0,
        //   tickCount: 4,
        // });
        this.chart.axis('type', {
          label: {
            textStyle: {
              fill: '#fff',
              fontSize:window.outerWidth/1960*16
            },
          },
          tickLine: {
            alignWithLabel: false,
            length: 0,
          },
        });

        this.chart.axis('value', false);
        this.chart.legend(false);
        let that = this;
        this.chart
          .interval()
          .position('type*value')
          .color('company', item => {
            return '#4CD4FA';
          })
          .opacity(1)
          .label('value', {
            useHtml: true,
            htmlTemplate: function htmlTemplate(text, item) {
              var a = item.point;
              // if (a.value == that.min || a.value == that.max) {
                return (
                  '<span class="g2-label-item"><p class="g2-label-item-value">' +
                  a.value +
                  '</p></div>'
                );
              // } else {
              //   return '';
              // }
            },
          })
          .adjust([
            {
              type: 'dodge',
              marginRatio: 1 / 32,
            },
          ]);
        this.chart.render();
      } else {
        this.chart.changeData(data);
      }
    },
  },
};
</script>
  
  <style lang="scss">
.CampusRank {
  height: 100%;
  width: 100%;
}
.g2-label-item-value {
  color: #fff;
  font-size: 1vw;
  padding:0px 6px;
  height: 1.4vw;
  text-align: center;
  vertical-align: middle;
  line-height: 1.4vw;
  border-radius: 0.7vw;
  background-color: cadetblue;
  margin-bottom: 20px;
}
</style>
  